import { Platform } from 'react-native';
import {
  WC_BRAND_DEFAULT,
  WC_BRAND_IOS_APP_STORE,
  type WcBrand,
} from './wcBrand.constants';

export { WC_BRAND_DEFAULT, WC_BRAND_IOS_APP_STORE, type WcBrand } from './wcBrand.constants';

/** App Store Guideline 5.2.1 — native iOS only; web and Android keep WC 2026. */
export function isNativeIosAppStoreBranding(): boolean {
  return Platform.OS === 'ios';
}

export function getWcBrand(): WcBrand {
  return isNativeIosAppStoreBranding() ? WC_BRAND_IOS_APP_STORE : WC_BRAND_DEFAULT;
}

/** Main screen heading above matches / leaderboard / squads tabs */
export function getWorldCupScreen() {
  const brand = getWcBrand();
  return {
    TITLE: brand.SHORT,
    YEAR: brand.YEAR,
    HEADER_OPEN_MENU_ACCESSIBILITY: 'Open menu',
    HEADER_WORLD_CUP_RULES_ACCESSIBILITY: `${brand.NAME} rules`,
    HEADER_WORLD_CUP_RULES_TEST_ID: 'worldcup-header-world-cup-rules',
  } as const;
}
